export default __webpack_public_path__ + "static/media/gas-price.48333313.png";